import { ref, readonly, watchEffect } from 'vue'
import { useEventListener, watchIgnorable, useIntervalFn } from '@vueuse/core'

/** @param {HTMLVideoElement?} video */
const isVideoPlaying = (video) => video && (
    video?.currentTime > 0 &&
    !video?.paused &&
    !video?.ended &&
    video?.readyState > 2
)

/** @param {import('vue').Ref<HTMLVideoElement?>} elRef */
export default (elRef) => {
    const isReady = ref(false)
    const isPlaying = ref(false)

    // Reflect changes to isPlaying
    const { ignoreUpdates: ignorePlayingUpdates } = watchIgnorable(isPlaying, (playing) => {
        if (!elRef.value) return
        elRef.value[playing ? 'play' : 'pause']()
    })

    watchEffect(() => {
        if (!elRef.value) return
        useEventListener(elRef.value, 'play', () => ignorePlayingUpdates(() => isPlaying.value = true))
        useEventListener(elRef.value, 'pause', () => ignorePlayingUpdates(() => isPlaying.value = false))
        useEventListener(elRef.value, 'ended', () => ignorePlayingUpdates(() => isPlaying.value = false))

        const { pause } = useIntervalFn(() => {
            if (!isVideoPlaying(elRef.value)) return
            isReady.value = true
            pause()
        }, 100)
    })

    return {
        isReady: readonly(isReady), isPlaying
    }
}